import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {updateWizardList} from "../wizardActions";
import {updateWizardNodesCount} from "../wizardFlowActions";
import WizardGroupsTopButtonsCopyPaste from "./WizardGroupsTopButtonsCopyPaste";

const WizardGroupsTopButtons = (props) => {

  const {wizardActiveItem, updateWizardList, wizardGroups, wizardNodes, wizardEdges, updateWizardNodesCount,
    wizardPopupOpened, wizardNodeInputFocused} = props;

  if (!wizardActiveItem || !wizardGroups) {
    return null
  }

  const selectedWizardNodes = wizardNodes.filter(wizardNode => wizardNode.selected && (wizardNode.type !== "input"));
  const selectedWizardEdges = wizardEdges.filter(wizardEdge => wizardEdge.selected);

  const toggleSelectedClick = (toggle) => {
    if (!selectedWizardNodes.length && !selectedWizardEdges.length) {
      return false
    }
    if (selectedWizardNodes.length) {
      wizardActiveItem.wizardGroups = wizardGroups.map(wizGroup => {
        if (selectedWizardNodes.some(wizardNode => wizardNode.id === wizGroup.id)) {
          wizGroup.enabled = toggle;
        }
        return wizGroup
      })
    }
    if (selectedWizardEdges.length) {
      wizardActiveItem.wizardEdges = wizardEdges.map(wizardEdge => {
        if (wizardEdge.selected) {
          wizardEdge.disabled = !toggle;
          wizardEdge.className = wizardEdge.disabled ? "disabled" : null
          wizardEdge.animated = wizardEdge.disabled;
        }
        return wizardEdge
      })
    }
    updateWizardList(wizardActiveItem);
    updateWizardNodesCount();
  }

  const deleteSelectedClick = () => {
    if (!selectedWizardNodes.length && !selectedWizardEdges.length) {
      return false
    }
    if (selectedWizardNodes.length) {
      wizardActiveItem.wizardGroups = wizardGroups.filter(wizGroup => {
        return !selectedWizardNodes.some(wizardNode => wizardNode.id === wizGroup.id)
      });
      wizardActiveItem.wizardNodes = wizardNodes.filter(wizardNode => !wizardNode.selected);
    }
    wizardActiveItem.wizardEdges = wizardEdges.filter(wizardEdge => {
      return !wizardEdge.selected
        && wizardActiveItem.wizardNodes.some(node => node.id === wizardEdge.source)
        && wizardActiveItem.wizardNodes.some(node => node.id === wizardEdge.target)
    });
    updateWizardList(wizardActiveItem);
    updateWizardNodesCount();
  }

  const deleteListener = (event) => {
    if (wizardPopupOpened || wizardNodeInputFocused) {
      return
    }
    if (event.key === "Delete" || event.keyCode === 46) {
      deleteSelectedClick();
    }
  }

  useEffect(() => {
    document.removeEventListener("keydown", deleteListener); // we need to delete old listener with other selected values on update
    document.addEventListener("keydown", deleteListener);
    return () => {
      document.removeEventListener("keydown", deleteListener);
    }
  }, [wizardActiveItem, selectedWizardNodes])

  const buttonsDisabled = !wizardGroups.length || (!selectedWizardNodes.length && !selectedWizardEdges.length);

  const allSelectedEnabled = selectedWizardNodes.every(wizNode => wizardGroups.some(wizGroup => (wizNode.id === wizGroup.id) && wizGroup.enabled))
    && selectedWizardEdges.every(wizardEdge => !wizardEdge.disabled);


  return (
    <div className="wizard-top">
      <div className="wizard-top__left">
        {wizardActiveItem.name ? <h2 className="ui-title--gray margin-0">{wizardActiveItem.name}</h2> : null}
      </div>
      <div className="wizard-top__right wizard-top__right--110">
        <WizardGroupsTopButtonsCopyPaste buttonsDisabled={buttonsDisabled}
                                         selectedWizardNodes={selectedWizardNodes}
                                         selectedWizardEdges={selectedWizardEdges}
                                         wizardActiveItem={wizardActiveItem}/>
        <button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--with-icon"
          + (buttonsDisabled ? " ui-button5--disabled" : "")}
                onClick={() => toggleSelectedClick(!allSelectedEnabled)}>
          <span className="ui-button-icon ui-button-icon--disable"/>
          <FormattedMessage id={allSelectedEnabled ? "wizard.groups.disableSelected" : "wizard.groups.enableSelected"}/>
        </button>
        <button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--with-icon"
          + (buttonsDisabled ? " ui-button5--disabled" : "")}
                onClick={deleteSelectedClick}>
          <span className="ui-button-icon ui-button-icon--delete"/>
          <FormattedMessage id="wizard.groups.deleteSelected"/>
        </button>
      </div>
    </div>
  )
};

WizardGroupsTopButtons.propTypes = {
  wizardActiveItem: PropTypes.object.isRequired
}

const mapStateToProps = (store, ownProps) => {
  const {wizardList, wizardPopupOpened, wizardNodeInputFocused} = store.wizardState;
  const {wizardGroups, wizardNodes, wizardEdges} = ownProps.wizardActiveItem;

  return {
    wizardPopupOpened,
    wizardList,
    wizardGroups,
    wizardNodes,
    wizardEdges,
    wizardNodeInputFocused,
  };
};

const mapDispatchToProps = {
  updateWizardList,
  updateWizardNodesCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardGroupsTopButtons)
)
